import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  
  // Mock data for featured trips (usually would come from an API)
  const featuredTrips = [
    {
      id: 1,
      title: 'Guatemala (+infosessie)',
      description: 'Wat een reis!',
      price: '€ 3.199',
      image: '/guatemala.jpg',
      link: '/reisaanbod/begeleide-rondreizen/guatemala',
    },
    {
      id: 2,
      title: 'Noorse Fjorden 2025 & 2026',
      description: 'Ontdek de reis uit onze VTM-spot. Wat een prachtige ervaring aan een zéér straffe prijs!',
      price: '€ 1.399',
      image: '/norway.jpg',
      link: '/reisaanbod/cruises/noorse-fjorden',
    },
    {
      id: 3,
      title: 'Benidorm is back!',
      description: '15 of 29 dagen 4****-hotel, volpension. Vlieg vanuit Oostende, Antwerpen of Brussel aan de scherpste tarieven!',
      price: '€ 899',
      image: '/spain.jpg',
      link: '/reisaanbod/hotels-strand/benidorm',
    },
    {
      id: 4,
      title: 'Ecuador & de Galapagos',
      description: 'Adembenemende rondreis + ontdek de Galapagos eilanden (+ themadag)',
      price: '€ 4.999',
      image: '/galapagos.jpg',
      link: '/reisaanbod/begeleide-rondreizen/ecuador-galapagos',
    },
  ];

  // State for carousel
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-rotate carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === featuredTrips.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [featuredTrips.length]);

  // Carousel controls
  const nextSlide = () => setCurrentSlide((prev) => (prev === featuredTrips.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentSlide((prev) => (prev === 0 ? featuredTrips.length - 1 : prev - 1));
  const goToSlide = (index: number) => setCurrentSlide(index);

  const premiumTrips = [
    {
      id: 1,
      title: 'Cornwall (Luxe belevenisreis)',
      price: '€ 1.699',
      image: 'https://images.unsplash.com/photo-1600977490177-19464da88473?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/begeleide-rondreizen/cornwall',
    },
    {
      id: 2,
      title: 'Griekenland - Klassieke rondreis',
      price: '€ 1.549',
      image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/begeleide-rondreizen/griekenland',
    },
    {
      id: 3,
      title: '20-daagse All inclusive luxe cruise Panamakanaal, Zuid-Amerika & Caraïben',
      price: '€ 4.999',
      image: 'https://images.unsplash.com/photo-1599640842225-85d111c60e6b?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/cruises/panama',
    },
    {
      id: 4,
      title: '10-Daagse All Inclusive Cruise Caraïben & Antillen met het allernieuwste schip van MSC - World America',
      price: '€ 2.699',
      image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/cruises/caribbean',
    },
  ];

  const topTrips = [
    {
      id: 1,
      title: 'TOPPER 2025: ALL IN cruise Middellandse Zee met het meest indrukwekkende schip ter wereld MSC World Europa.',
      price: '€ 1.249',
      image: 'https://images.unsplash.com/photo-1566375638555-42995f2ffe25?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/cruises/mediterraan',
    },
    {
      id: 2,
      title: 'Poolervaring in Lapland',
      price: '€ 1.799',
      image: 'https://images.unsplash.com/photo-1516466723877-e4ec1d736c8a?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/begeleide-rondreizen/lapland',
    },
    {
      id: 3,
      title: 'Oman (luxe rondreis)',
      price: '€ 2.649',
      image: 'https://images.unsplash.com/photo-1528702748617-c64d49f918af?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/begeleide-rondreizen/oman',
    },
    {
      id: 4,
      title: 'Unieke Armenië rondreis (incl. Zijderoute)',
      price: '€ 1.949',
      image: '/armenia.jpg',
      link: '/reisaanbod/begeleide-rondreizen/armenie',
    },
    {
      id: 5,
      title: 'Strandvakantie in Senegal aan topvoorwaarden (nieuw Riu hotel - all inclusive)',
      price: '€ 1.299',
      image: 'https://images.unsplash.com/photo-1580541631950-7282082b03fe?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/hotels-strand/senegal',
    },
  ];

  const categories = [
    {
      id: 1,
      title: 'Cruises',
      description: 'Een cruise blijft de ideale manier om relaxt te reizen. U leert vele bestemmingen kennen en het schip brengt er U elke dag naartoe terwijl U geniet van alle faciliteiten aan boord.',
      image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/cruises',
    },
    {
      id: 2,
      title: 'Begeleide rondreizen',
      description: 'Een begeleide rondreis is de ideale manier om, vakkundig bijgestaan door onze gidsen, een bestemming te leren kennen. Verre Oosten, Zuid Amerika of het klassieke Italie?',
      image: 'https://images.unsplash.com/photo-1501555088652-021faa106b9b?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/begeleide-rondreizen',
    },
    {
      id: 3,
      title: 'Hotel & strandverblijven',
      description: 'Zin in een ontspannend hotelverblijf? Languit genieten in Spanje, Griekeland, Aruba of Jamaica? Of houdt U meer van de natuur in Oostenrijk of Madeira?',
      image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/hotels-strand',
    },
    {
      id: 4,
      title: 'Citytrips',
      description: 'Wij organiseren vaak leuke citytrips met vele extra\'s. Wat dacht U van Parijs, Rome, New York? Onze begeleiders leren u de steden als geen ander kennen.',
      image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/citytrips',
    },
    {
      id: 5,
      title: 'Riviercruises',
      description: 'Varen langsheen de kronkelende rivieren en aanmeren in de mooiste historische steden? Een riviercruise combineert city-hopping met een zeer ontspannen manier van reizen.',
      image: 'https://images.unsplash.com/photo-1644013814239-1257ebbd6db8?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/riviercruises',
    },
    {
      id: 6,
      title: 'Kortbij',
      description: 'Je moet niet ver reizen om knappe plaatsen te ontdekken. Kortbij is zoveel te beleven. Ontdek het hier ...',
      image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=800&h=600&auto=format&fit=crop',
      link: '/reisaanbod/kortbij',
    },
  ];

  const themaDays = [
    {
      id: 1,
      date: '02-05-2025',
      title: 'Brazilië + Prachtige cruise op de Amazone',
      link: '/themadagen/brazilie',
    },
    {
      id: 2,
      date: '03-05-2025',
      title: 'Oman (luxe rondreis)',
      link: '/themadagen/oman',
    },
  ];

  return (
    <div className="bg-background-light">
      {/* Hero Banner / Carousel */}
      <section className="relative h-96 overflow-hidden">
        {/* Carousel slides */}
        <div className="h-full relative">
          {featuredTrips.map((trip, index) => (
            <div 
              key={trip.id}
              className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            >
              <img 
                src={trip.image || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1200&auto=format&fit=crop'} 
                alt={trip.title}
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1200&auto=format&fit=crop';
                }}
              />
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
              
              {/* Content overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center px-4 text-white">
                  <h1 className="text-4xl md:text-5xl font-bold mb-2">De Blauwe Vogel</h1>
                  <p className="text-xl mb-3">{t('header.tagline')}</p>
                  <h2 className="text-2xl md:text-3xl font-semibold mb-4">{trip.title}</h2>
                  <p className="text-lg mb-6">{trip.description}</p>
                  <div className="flex gap-3 justify-center">
                    <Link 
                      to="/reisaanbod" 
                      className="inline-block bg-white text-primary hover:bg-gray-100 font-bold py-3 px-6 rounded-lg transition duration-300"
                    >
                      {t('home.discover')}
                    </Link>
                    <Link 
                      to={trip.link} 
                      className="inline-block bg-primary text-white hover:bg-primary-dark font-bold py-3 px-6 rounded-lg transition duration-300"
                    >
                      {t('home.viewTrip')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Carousel controls */}
        <button 
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full"
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button 
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full"
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Carousel indicators */}
        <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2">
          {featuredTrips.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full ${
                index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Featured Trips */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredTrips.map((trip) => (
              <FeaturedTripCard key={trip.id} trip={trip} />
            ))}
          </div>
        </div>
      </section>

      {/* Travel Categories */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-10 text-center">{t('home.travelCategories')}</h2>
          
          {/* Vacation Period Selector - Placeholder */}
          <div className="mb-12 p-4 border border-gray-200 rounded-lg shadow-sm">
            <p className="font-bold mb-2">{t('home.vacationPeriod')}</p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-gray-100 rounded-md text-sm cursor-pointer hover:bg-primary hover:text-white transition">april 2025</span>
              <span className="px-3 py-1 bg-gray-100 rounded-md text-sm cursor-pointer hover:bg-primary hover:text-white transition">mei 2025</span>
              <span className="px-3 py-1 bg-gray-100 rounded-md text-sm cursor-pointer hover:bg-primary hover:text-white transition">juni 2025</span>
              {/* More periods would go here */}
            </div>
          </div>
          
          {/* Category Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category) => (
              <CategoryCard key={category.id} category={category} />
            ))}
          </div>
        </div>
      </section>

      {/* Premium Trips */}
      <section className="py-16 bg-background-light">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-10 text-center">{t('home.premiumTrips')}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {premiumTrips.map((trip) => (
              <TripCard key={trip.id} trip={trip} />
            ))}
          </div>
        </div>
      </section>

      {/* Top Picks */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-10 text-center">{t('home.topPicks')}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {topTrips.map((trip) => (
              <TripCard key={trip.id} trip={trip} />
            ))}
          </div>
        </div>
      </section>

      {/* Gift Cards & Newsletter */}
      <section className="py-16 bg-background-light">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Gift Card */}
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <h3 className="text-2xl font-bold mb-4">{t('home.giftCards')}</h3>
              <p className="mb-6">
                {t('home.giftCardsText')}
              </p>
              <Link 
                to="/cadeaubonnen" 
                className="inline-block bg-primary hover:bg-primary-dark text-white font-bold py-2 px-6 rounded transition duration-300"
              >
                {t('home.orderHere')}
              </Link>
            </div>

            {/* Newsletter */}
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <h3 className="text-2xl font-bold mb-4">{t('home.newsletter')}</h3>
              <p className="mb-6">
                {t('home.newsletterText')}
              </p>
              <Link 
                to="/nieuwsbrief" 
                className="inline-block bg-primary hover:bg-primary-dark text-white font-bold py-2 px-6 rounded transition duration-300"
              >
                {t('home.subscribe')}
              </Link>
              <p className="mt-4">
                <Link to="/nieuwsbrieven" className="text-primary hover:underline">
                  {t('home.viewRecentNewsletters')}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Theme Days */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-10 text-center">{t('home.themeDays')}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {themaDays.map((day) => (
              <div key={day.id} className="bg-background-light p-6 rounded-lg shadow-sm">
                <div className="text-center mb-4">
                  <span className="block text-lg text-gray-600">{day.date}</span>
                  <h3 className="text-xl font-bold">{day.title}</h3>
                </div>
                <div className="text-center">
                  <Link 
                    to={day.link} 
                    className="inline-block bg-primary hover:bg-primary-dark text-white font-bold py-2 px-6 rounded transition duration-300"
                  >
                    {t('home.infoAndRegister')}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About */}
      <section className="py-16 bg-background-light">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6 text-center">{t('home.about.title')}</h2>
          <p className="text-center max-w-4xl mx-auto">
            {t('home.about.text')}
          </p>
        </div>
      </section>
    </div>
  );
};

// Card Components
type TripProps = {
  id: number;
  title: string;
  price: string;
  image: string;
  link: string;
  description?: string;
};

const FeaturedTripCard: React.FC<{ trip: TripProps }> = ({ trip }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
      <div className="h-48 overflow-hidden">
        <img 
          src={trip.image || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&h=600&auto=format&fit=crop'} 
          alt={trip.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&h=600&auto=format&fit=crop';
          }}
        />
      </div>
      <div className="p-4">
        <h3 className="font-bold text-xl mb-2">{trip.title}</h3>
        <p className="text-gray-700 mb-4">{trip.description}</p>
        <div className="flex justify-between items-center">
          <span className="text-xl font-bold text-primary">{t('trips.from')} {trip.price}</span>
          <Link 
            to={trip.link} 
            className="text-primary hover:text-primary-dark font-medium"
          >
            meer info
          </Link>
        </div>
      </div>
    </div>
  );
};

const TripCard: React.FC<{ trip: TripProps }> = ({ trip }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
      <div className="h-40 overflow-hidden">
        <img 
          src={trip.image || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&h=600&auto=format&fit=crop'} 
          alt={trip.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&h=600&auto=format&fit=crop';
          }}
        />
      </div>
      <div className="p-4">
        <h3 className="font-bold text-lg mb-3 line-clamp-2">{trip.title}</h3>
        <span className="block text-xl font-bold text-primary">{trip.price}</span>
      </div>
    </div>
  );
};

type CategoryProps = {
  id: number;
  title: string;
  description: string;
  image: string;
  link: string;
};

const CategoryCard: React.FC<{ category: CategoryProps }> = ({ category }) => {
  return (
    <div className="bg-background-light rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
      <div className="h-48 overflow-hidden">
        <img 
          src={category.image || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&h=600&auto=format&fit=crop'} 
          alt={category.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=800&h=600&auto=format&fit=crop';
          }}
        />
      </div>
      <div className="p-4">
        <h3 className="font-bold text-xl mb-2">{category.title}</h3>
        <p className="text-gray-700 mb-4 text-sm">{category.description}</p>
      </div>
    </div>
  );
};

export default HomePage; 